export default __webpack_public_path__ + "45e973a7eb8beec9d40f97ee04698b7f.svg";